import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

type AuthFooterLink = {
  labelKey: string;
  /** Absolute URL, or omit / leave empty until production destination is confirmed. */
  href?: string;
};

/**
 * CUSTOMIZATION: Compact legal footer for Presidio auth shell (login/register/etc.).
 * Matches current myPresidio.com login footer content.
 */
@Component({
  selector: 'ish-presidio-auth-footer',
  templateUrl: './presidio-auth-footer.component.html',
  styleUrls: ['./presidio-auth-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
})
export class PresidioAuthFooterComponent {
  readonly year = new Date().getFullYear();

  readonly links: readonly AuthFooterLink[] = [
    {
      labelKey: 'login.footer.home',
      href: 'https://www.presidio.com/',
    },
    {
      labelKey: 'login.footer.careers',
      href: 'https://www.presidio.com/our-company/careers',
    },
    {
      labelKey: 'login.footer.privacy',
      href: 'https://www.presidio.com/privacy-policy/',
    },
    {
      labelKey: 'login.footer.cookies',
      href: 'https://www.presidio.com/page/928/cookie-policy',
    },
    {
      labelKey: 'login.footer.sitemap',
      href: 'https://www.presidio.com/sitemap',
    },
    {
      labelKey: 'login.footer.contact',
      href: 'https://www.presidio.com/content/contact-us',
    },
  ];
}
